import React, { useEffect, useState, useContext } from 'react'
import { useForm } from 'react-hook-form'
import Loader from 'react-loader-spinner'
import ModalInfo from '../modal-info/modal-info'
import { Context } from '../../../context/app-context'
import {
  costActivity,
  competitionId,
} from '../../../constants/activity-constants'

import sessionStorage from './../../../utils/userSessionStorage'
import gameServices from '../../../services/game-service'
import pointsServices from '../../../shared/services/my-points-service'
import useMediaQuery from '../../../utils/useMediaQuery'

import icon25 from './../../../assets/images/icon25.png'
import icon20 from './../../../assets/images/icon20.png'
import imgNoCover from './../../../assets/images/imgModalNoCover.png'

import './modal-redeem.scss'
import { siteUrl } from '../../../shared/utils/siteUrl'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import Show from '../../../utils/show'
import { jsonToHash } from '../../../utils/crypto'

const LOCALE =
  [
    'es-AR',
    'es-CL',
    'es-PE',
    'es-EC',
    'es-DO',
    'es-BO',
    'es-PR',
    'es-PY',
    'es-UY',
  ].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'

const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY'

const noCover = LOCALE === 'es-BO' || LOCALE === 'es-UY'

const userInfo = getUserInfo()
const handleClick = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_Redencion_VMatch',
    label,
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

const activeModalUps = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_pop_up_VMatch',
    label,
    action: 'view',
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

const handleBtnModalUps = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_pop_up_VMatch',
    label,
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

export default function ModalRedeem(props) {
  const { handleSuccess } = props
  const { dispatch } = useContext(Context)
  const [session] = useState(new sessionStorage())
  const { register, handleSubmit, reset } = useForm()
  const [userData, setUserData] = useState({ name: '', userPoints: 0 })
  const [msgKeyError, setMsgKeyError] = useState(null)
  const [msgKeyNotPoints, setMsgKeyNotPoints] = useState(null)
  const [msgKeySuccess, setMsgKeySuccess] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const isMobile = useMediaQuery()
  const onSubmitKey = data => {
    if (isLoading) return
    setIsLoading(true)
    let payload = {
      key: { code: data.code.toUpperCase() },
      activity: competitionId.toString(),
    }
    var config = {
      headers: {
        Authorization: session.getToken().idToken,
      },
    }
    pointsServices
      .postMyKeys(payload, false, config)
      .then(res => {
        if (res.status === 200) {
          session.authUserInfo({
            handleSuccess: res => {
              setUserData(res.data)
            },
          })
          setMsgKeySuccess(res.userMessage)
          setTimeout(() => {
            setMsgKeySuccess(null)
          }, 2500)
        } else {
          setMsgKeyError(res.userMessage)
          activeModalUps('La clave que ingresaste no es correcta')
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setIsLoading(false)
        reset({})
      })
  }

  const handleRedimir = () => {
    if (isLoading) return
    setIsLoading(true)
    let points = userData.userPoints
    if (
      points.pointsAccumulation + points.pointsPresent + points.pointsToExpire <
      costActivity
    ) {
      setMsgKeyNotPoints('No tienes puntos suficientes para participar.')
      setTimeout(() => {
        setMsgKeyNotPoints(null)
      }, 4000)
      setIsLoading(false)
      return
    }

    var tokenId = session.getToken().idToken
    var config = {
      headers: {
        Authorization: tokenId,
      },
    }
    gameServices.getTokenGame(competitionId, config).then(res => {
      if (res.status === 200) {
        dispatch({
          type: 'set-context',
          payload: {
            tokenParticipation: res.data.tokenGame,
          },
        })
        if (handleSuccess) handleSuccess()
      } else if (res.errorCode === 'DEM061') {
        // "DEM061": Sin participacion pendiente
        gameServices
          .postGameParticipationRedeem(competitionId, config)
          .then(res => {
            if (res.status === 200) {
              // si tiene un token activo Mostrar mensaje y redireccionar
              dispatch({
                type: 'set-context',
                payload: {
                  tokenParticipation: res.data.tokenGame,
                },
              })
              if (handleSuccess) handleSuccess()
            } else {
              setMsgKeyNotPoints(res.userMessage)
              setTimeout(() => {
                setMsgKeyNotPoints(null)
                setIsLoading(false)
              }, 2500)
            }
          })
      } else {
        // Example: "UEM026"= el concurso ya finalizo
        setMsgKeyNotPoints(res.userMessage)
        setTimeout(() => {
          setMsgKeyNotPoints(null)
          setIsLoading(false)
        }, 4000)
      }
    })
  }

  useEffect(() => {
    session.authUserInfo({
      handleSuccess: res => {
        setUserData(res.data)
      },
    })
  }, [session])

  return (
    <>
      {(msgKeyError && (
        <ModalInfo
          {...{
            //  title: '¡Uuuups!',
            body: (
              <div className="modal-redeem --upps-view">
                <h2 class="title">¡Uuuups!</h2>
                <br />
                <br />
                <Show valid={!italatam}>
                  <p>
                    La clave que ingresaste <br />
                    no es correcta, recuerda ingresarla <br />
                    sin guiones ni espacios.
                  </p>
                </Show>
                <Show valid={italatam}>
                  <p>
                    La clave que ingresaste <br />
                    no es correcta. Recordá ingresarla <br />
                    sin guiones ni espacios.
                  </p>
                </Show>

                <br />
                <br />
                <div>
                  <button
                    className="f-btn-submit-redention btn-secondary--2 "
                    onClick={() => {
                      setMsgKeyError(null)
                      handleBtnModalUps('Vuelve a intentarlo')
                    }}
                  >
                    <Show valid={!italatam}>Vuelve a intentarlo</Show>
                    <Show valid={italatam}>Volvé a intentarlo</Show>
                  </button>
                </div>
              </div>
            ),
          }}
        />
      )) || (
        <div className="modal-redeem">
          <div className="modal-redeem-container">
            <div className="wrapper-star">
              <Show valid={!noCover}>
                <p className="wrapper-star__title">
                  Hola, <br />
                  <span>{userData.name}</span>
                </p>
                <p className="wrapper-star__pPoints">
                  <Show
                    valid={
                      LOCALE === 'default' ||
                      LOCALE === 'es-EC' ||
                      LOCALE === 'es-DO' ||
                      LOCALE === 'es-PR'
                    }
                  >
                    Para poder {isMobile && <br />} jugar debes redimir
                  </Show>
                  <Show valid={italatam}>
                    Para poder {isMobile && <br />} jugar debés canjear
                  </Show>
                  <Show valid={LOCALE === 'es-PE' || LOCALE === 'es-CL'}>
                    Para poder {isMobile && <br />} jugar debes canjear
                  </Show>
                </p>
                {!isMobile && <br />}
                <img
                  className="wrapper-star__pPoints__icon25"
                  src={LOCALE === 'default' ? icon25 : icon20}
                  alt=""
                />
                {!isMobile && <br />}
                <p className="wrapper-star__pPoints">
                  <span>1 oportunidad = {costActivity} puntos</span>
                </p>
                {msgKeyNotPoints && (
                  <p className="key-error-message">*{msgKeyNotPoints}</p>
                )}
                {(isLoading && (
                  <Loader
                    type="TailSpin"
                    color="#ffffff"
                    height={30}
                    width={30}
                  />
                )) || (
                  <button
                    className="f-btn-submit-redention btn-secondary--2 size-11"
                    onClick={() => {
                      handleRedimir()
                      handleClick('Quiero redimir y jugar')
                    }}
                  >
                    <Show
                      valid={
                        LOCALE === 'default' ||
                        LOCALE === 'es-EC' ||
                        LOCALE === 'es-DO' ||
                        LOCALE === 'es-PR'
                      }
                    >
                      Quiero redimir y jugar
                    </Show>
                    <Show
                      valid={
                        LOCALE === 'es-AR' ||
                        LOCALE === 'es-PE' ||
                        LOCALE === 'es-CL' ||
                        LOCALE === 'es-PY'
                      }
                    >
                      Quiero canjear y jugar
                    </Show>
                  </button>
                )}
                <form onSubmit={handleSubmit(onSubmitKey)}>
                  <div className="modal-redeem-input-container">
                    <Show valid={LOCALE === 'default' || LOCALE === 'es-EC'}>
                      <p className="modal-redeem-input-container__textInfo">
                        <span>¿No tienes puntos?</span> <br />
                        Inscribe aquí las claves de tus productos Nosotras y
                        acumula puntos para jugar.
                      </p>
                    </Show>
                    <Show valid={LOCALE === 'es-DO' || LOCALE === 'es-PR'}>
                      <p className="modal-redeem-input-container__textInfo">
                        <span>¿No tienes puntos para redimir?</span> <br />
                        Inscribe aquí las claves de tus productos Nosotras y
                        acumula puntos para jugar.
                      </p>
                    </Show>
                    <Show valid={LOCALE === 'es-PE' || LOCALE === 'es-CL'}>
                      <p className="modal-redeem-input-container__textInfo">
                        <span>¿No tienes puntos para canjear?</span> <br />
                        Inscribe aquí las claves de tus productos Nosotras y
                        acumula puntos para jugar.
                      </p>
                    </Show>
                    <Show valid={italatam}>
                      <p className="modal-redeem-input-container__textInfo">
                        <span>¿No tenés puntos para canjear?</span> <br />
                        Inscribí acá las claves de tus productos Nosotras y
                        acumulá puntos para jugar.
                      </p>
                    </Show>

                    <input
                      className="f-input-redention"
                      maxLength={10}
                      ref={register({
                        required: true,
                      })}
                      placeholder="- - - - - - "
                      name="code"
                    />
                    {msgKeySuccess && (
                      <p className="key-success-message">*{msgKeySuccess}</p>
                    )}
                  </div>
                  {(isLoading && (
                    <Loader
                      type="TailSpin"
                      color="#ffffff"
                      height={30}
                      width={30}
                    />
                  )) || (
                    <button
                      className="f-btn-submit-key btn-primary size-11"
                      type="submit"
                      onClick={() => {
                        if (msgKeySuccess) {
                          handleClick('Enviar')
                        } else {
                          console.log('Clave incorrecta')
                        }
                      }}
                    >
                      Enviar
                    </button>
                  )}
                  <br />
                  <a
                    className="link-to "
                    target="_blank"
                    rel="noopener noreferrer"
                    href={siteUrl + '/mis-puntos/que-son/'}
                    onClick={() =>
                      handleClick('Quiero saber como ingresar mis claves')
                    }
                  >
                    Quiero saber cómo ingresar mis claves
                  </a>
                </form>
              </Show>
              <Show valid={noCover}>
                <p className="wrapper-star__pPoints modalNoCover">
                  Entre ciclos, hormonas, dolor y placer a veces pensamos que
                  nuestro cuerpo se sale de control.
                  <br />
                  <br />
                  <span className="modalNoCover__spanText">
                    ¿Tú también lo has sentido?
                  </span>
                  <br />
                  <br />
                  <Show valid={LOCALE === 'es-BO'}>
                    Juega en{' '}
                    <span className="modalNoCover__spanText">V-Match,</span>{' '}
                    elimina tabúes.
                  </Show>
                  <Show valid={LOCALE === 'es-UY'}>
                    Jugá en{' '}
                    <span className="modalNoCover__spanText">V-Match,</span>{' '}
                    eliminá tabúes.
                  </Show>
                  <br />
                  <br />
                  <img
                    className="wrapper-star__imgModal"
                    src={imgNoCover}
                    alt="imgGameNoCover"
                  />
                </p>
                <button
                  className="f-btn-submit-key btn-primary size-11"
                  onClick={() => {
                    handleRedimir()
                  }}
                >
                  Jugar
                </button>
              </Show>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
